import packageJson from '../../../../package.json';

export interface IEnvironment {
  appInsights: {
    cloudRole: string;
    instrumentationKey: string | null;
  };
  areExceptionsLoggedIntoBrowserConsole: boolean;
  bookDemoUrl: string;
  production: boolean;
  ssoAuthUrl: string;
  ssoEnv: string;
  ssoLogoutUrl: string;
  ssoSilentAuthUrl: string;
  ssoUrl: string;
  version: string;
}

export const defaultEnvironmentConfigs = {
  areExceptionsLoggedIntoBrowserConsole: true,
  bookDemoUrl: 'https://scw.ai/book-demo/',
  production: true,
  ssoAuthUrl: '/selfclient/auth/',
  ssoEnv: 'DEV',
  ssoLogoutUrl: '/selfclient/logout',
  ssoSilentAuthUrl: '/selfclient/extend/',
  ssoUrl: 'https://df-sso.scm3d.com',
  version: packageJson.version,
};
